/*
 * @Author: xuliqi
 * @Date: 2019-12-26 14:58:31
 * @Description:
 */
import axios from 'axios'
import router from '../routers'
import config from '../config'

axios.defaults.baseURL = config.BaseUrl; // 设置全局默认基本信息
axios.defaults.headers['Content-Type'] = 'application/json'; // 设置默认的请求头的Content-Type

/**
 * @description 封装post请求的方法
 * @param {*} url 请求的地址
 * @param {*} data 请求的数据
 * @returns 数据请求的promise对象
 */
const postRequest = (url, data) => axios.post(url, data)

/**
 * @description 封装post请求的方法(发送文件时使用)
 * @param {*} url 请求的地址
 * @param {*} data 请求的数据
 * @returns 数据请求的promise对象
 */
const postFileRequest = (url, data) => axios.post(url, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
})

/**
 * @description 封装的get请求的方法
 * @param {*} url 请求的地址
 * @param {*} data  请求的数据
 * @returns 数据请求的promise对象
 */
const getRequest = (url, data) => axios.get(url, { params: data })


/* 重新封装get请求(适用于pc端调用) */
const getRequestNew = (url, data, that) => new Promise((resolve, reject) => {
    axios.get(url, { params: data }).then(res => {
        if (res.code == 200) {
            resolve(res)
        } else {
            that.$Message.error(res.message)
            reject()
        }
    }).catch(() => {
        that.$Message.error('请联系网站管理员')
        reject()
    })
})

/* 重新封装post请求(适用于pc端调用) */
const postRequestNew = (url, data, that) => new Promise((resolve, reject) => {
    axios.post(url, data).then(res => {
        if (res.code == 200) {
            resolve(res)
        } else {
            that.$Message.error(res.message)
            reject()
        }
    }).catch(() => {
        that.$Message.error('请联系网站管理员')
        reject()
    })
})


/**
 * @description 封装的get请求二进制流文件的方法
 * @param {*} url 请求的地址
 * @param {*} data  请求的数据
 * @returns 数据请求的promise对象
 */
const getBlobRequest = (url, data) => axios.get(url, { params: data, responseType: "blob" })

/**
 * @description 封装同步上传文件
 * @param {*} url 请求的地址
 * @param {*} imageFiles  上传的数据地址
 * @returns 数据请求的promise对象
 */
function sendImages(imageFiles) {
    return Promise.all(imageFiles.map((imageFile) => {
        return new Promise(function (resolve, reject) {
            wx.uploadFile({
                url: 'https://nongyexiaochengxu.site:21443/finalProject/upload/upload',
                filePath: imageFile,
                name: 'file',
                success: (res) => {
                    resolve(JSON.parse(res.data).data)
                }
            });
        })
    }))
}

/**
 * @description: 记录日志的方法
 * @param {
   module,  操作模块
   type,   操作类型
   isSuccess,  是否成功  T/F
   reason  失败原因
   }
 */
import Config from "../config"
function addLog(module, type, isSuccess = 'T', reason = '') {
    let userInfo = JSON.parse(localStorage.getItem('Role'))
    postRequest(Config.SXG_baseUrl + '/api/casemanager/SaveSysLog', {
        tablename: 'SystemLog',
        DLID: userInfo.ID,
        OUserJid: userInfo.UserJid,
        ODocName: userInfo.DocName,
        OImg: userInfo.ImgUrl,
        Cellphone: userInfo.Cellphone,
        Modules: module,
        Type: type,
        Client: 'Web端',
        IsSuccess: isSuccess,
        FailLog: reason
    })
}

// 请求拦截器
axios.interceptors.request.use(config => {
    if (sessionStorage.getItem('authorization')) {
        config.headers.Authorization = sessionStorage.getItem('authorization')
    }
    return config
})

// 响应拦截器
axios.interceptors.response.use(response => {
    if (response.headers.authorization) {
        sessionStorage.setItem('authorization', response.headers.authorization)
    }
    return response.data
}, err => {
    // 对响应错误做些什么
    // router.replace("/login");
    console.log("发送请求报错！");
    console.log(err.response);
    if (err.response.status == 401) {
        router.replace("/login");
    }
})

export default {
    postRequest,
    getRequest,
    getBlobRequest,
    postFileRequest,
    addLog,
    getRequestNew,
    postRequestNew
}